import httpRequest from "../apis/httpRequest";
import { FETCH_SERVICE, SERVICE_CHOOSE, FETCH_URL, CHOOSE_URL } from "./types";

// 获取业务数据
const fetchService = () => {
  return dispatch => {
    const request = httpRequest.get(FETCH_URL);
    request.then(function (res) {
      dispatch({
        type: FETCH_SERVICE,
        payload: res
      });
    });
  };
};
//记录选择的业务
const serviceChoose = id => {
  return dispatch => {
    const request = httpRequest.get(`${CHOOSE_URL}&id=${id}`);
    dispatch({
      type: SERVICE_CHOOSE,
      payload: request
    });
  };
};
export { fetchService, serviceChoose };
